import React from "react";
import { Link } from "react-router-dom";
import { Camera, X } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { useLang } from "../i18n/LanguageContext";
import useLocalDismiss from "../hooks/useLocalDismiss";

export function PhotoNudgeBanner() {
  const { data } = useApi("/members/me/photo-nudge");
  const { t } = useLang();
  const [dismissed, dismiss] = useLocalDismiss("photo-nudge-banner");
  if (!data?.show || dismissed) return null;
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-2xl border-2 border-gold bg-gold-light p-4" data-testid="photo-nudge-banner">
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-crimson text-parchment"><Camera size={20} /></span>
        <div>
          <p className="font-serif-display font-bold text-crimson">{t("You're featured in the Akwaaba strip!")}</p>
          <p className="text-sm text-foreground/80">{t("Add a profile photo so fellow members can put a face to your name on the website.")}</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Link to="/portal/profile" className="rounded-full bg-crimson px-4 py-2 text-sm font-semibold text-parchment hover:bg-crimson-hover" data-testid="photo-nudge-add">{t("Add my photo")}</Link>
        <button onClick={dismiss} className="rounded-full p-2 text-muted-foreground hover:bg-white/60" aria-label="Dismiss" data-testid="photo-nudge-dismiss"><X size={16} /></button>
      </div>
    </div>
  );
}
